
import * as OM from '@/model';
import * as Const from '@/const';
import * as VM from '@/viewmodel';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class datoAggiuntivo extends mixins(WithModel) {

    @Prop() config: OM.FormItemConfig;

    declare localValue: string[];

    created(){
        if(!this.localValue){
            this.localValue = [];
        }
        if(!this.config.isMultiSelect && this.localValue[0] == null){
            this.localValue[0] = "";
        }
    }

}
